/**
 * Team colour palette for kanban-team chips.
 *
 * Shared between `WorkspacesView`, the incident workspaces section, and the
 * card-incidents section so chips look consistent everywhere a team appears.
 */

export const KANBAN_TEAM_COLORS: Record<string, string> = {
  devteam: '#3498DB',
  buildteam: '#E67E22',
  eventteam: '#2ECC71',
  event: '#2ECC71',
  management: '#9B59B6',
};

export const KANBAN_TEAM_FALLBACK_COLOR = '#95A5A6';

export function kanbanTeamColor(team: string | null | undefined): string {
  if (!team) return KANBAN_TEAM_FALLBACK_COLOR;
  return KANBAN_TEAM_COLORS[team] ?? KANBAN_TEAM_FALLBACK_COLOR;
}
